var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 23,
    viewBox: "0 0 34 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H34V22.6667H0V0ZM17 5.66667C18.5029 5.66667 19.9442 6.26369 21.0069 7.3264C22.0696 8.3891 22.6667 9.83044 22.6667 11.3333C22.6667 12.8362 22.0696 14.2776 21.0069 15.3403C19.9442 16.403 18.5029 17 17 17C15.4971 17 14.0558 16.403 12.9931 15.3403C11.9304 14.2776 11.3333 12.8362 11.3333 11.3333C11.3333 9.83044 11.9304 8.3891 12.9931 7.3264C14.0558 6.26369 15.4971 5.66667 17 5.66667ZM7.55556 3.77778C7.55556 4.77971 7.15754 5.7406 6.44907 6.44907C5.7406 7.15754 4.77971 7.55556 3.77778 7.55556V15.1111C4.77971 15.1111 5.7406 15.5091 6.44907 16.2176C7.15754 16.9261 7.55556 17.887 7.55556 18.8889H26.4444C26.4444 17.887 26.8425 16.9261 27.5509 16.2176C28.2594 15.5091 29.2203 15.1111 30.2222 15.1111V7.55556C29.2203 7.55556 28.2594 7.15754 27.5509 6.44907C26.8425 5.7406 26.4444 4.77971 26.4444 3.77778H7.55556Z",
    fill: "#85BE49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/Payment.35004db612359bd6c91a3898b869bde8.svg";
export { ForwardRef as ReactComponent };